/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios';
import QS from 'qs';
import store from '@/store'
// 请求超时时间
// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.get['Content-Type'] = 'text/html;charset=UTF-8'
axios.defaults.withCredentials = true
// 请求拦截器
axios.interceptors.request.use(    
    config => {
        store.state.loadingAm = true
        return config
    },    
    error => {        
      
    })

// 响应拦截器
axios.interceptors.response.use(    
    response => {     
        store.state.loadingAm = false
            return response.data
    },
    // 服务器状态码不是200的情况    
    error => {        
        store.state.loadingAm = false
    }
);
/** 
 * get方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function get(url, params){    
    return new Promise((resolve, reject) =>{        
        axios.get(url, {            
            params: params        
        })        
        .then(res => {       
            resolve(res);        
        })        
        .catch(err => {            
            reject(err)        
        })    
    });
}
/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function post(url, params) {    
    return new Promise((resolve, reject) => {         
        axios.post(url, QS.stringify(params))        
        .then(res => {            
            resolve(res);        
        })        
        .catch(err => {            
            reject(err)        
        })    
    });
}

export default {
    get,
    post
}


// WEBPACK FOOTER //
// ./src/util/ajax.js